import { CollageDisplayCount, CollageLayout } from "../../photoCollages/models/PhotoCollageModel";
import { UploadPictureModel } from "../../pictures/models/PictureModel";
import { PriceDisplayType } from "./ProductModel";

export interface NewProductModelWrapper {
    group: NewGroupModel;
    lines: NewLineModel[];
    sizes: number[];
    codes: string[];
}

export const createNewProductModelWrapper = (): NewProductModelWrapper => ({
    group: createNewGroupModel(),
    lines: [],
    sizes: [],
    codes: []
});

export interface NewGroupModel {
    name: string;
    brandId: number;
    categoryIds: number[];
    specification: string;
    note: string;
    msrp: number;
    price: number;
    shipping: number;
    fee: number;
}

export const createNewGroupModel = (): NewGroupModel => ({
    name: "",
    brandId: 0,
    categoryIds: [],
    specification: "",
    note: "",
    msrp: 0,
    price: 0,
    shipping: 0,
    fee: 0
});

export interface NewLineModel {
    name: string;
    code: string;
    style: string;
    priceDisplayType: PriceDisplayType;
    deleted: boolean;
    active: boolean;
    approved: boolean;
    feature: ProductFeatureModel;
    products: NewProductModel[];
    uploadPicture?: UploadPictureModel;
}

export const createNewLineModel = (): NewLineModel => ({
    name: "",
    code: "",
    style: "",
    priceDisplayType: PriceDisplayType.show,
    deleted: false,
    active: false,
    approved: false,
    feature: createProductFeatureModel(),
    products: [],
    uploadPicture: undefined
});

export interface NewProductModel {
    sizeId?: number;
    code: string;
    codeOrder: number;
    barcode: string;
    msrp: number;
    price: number;
    shipping: number;
    fee: number;
}

export const createNewProductModel = (): NewProductModel => ({
    sizeId: undefined,
    code: "",
    codeOrder: 0,
    barcode: "",
    msrp: 0,
    price: 0,
    shipping: 0,
    fee: 0
});

export interface ProductFeatureModel {
    lineId: number;
    specialSale: boolean;
    topRate: boolean;
    topSale: boolean;
    newArrival: boolean;
    choice: boolean;
    alwaysApproved: boolean;
    alwaysCostConfirmed: boolean;
}

export const createProductFeatureModel = (): ProductFeatureModel => ({
    lineId: 0,
    specialSale: false,
    topRate: false,
    topSale: false,
    newArrival: false,
    choice: false,
    alwaysApproved: false,
    alwaysCostConfirmed: false
});

export interface NewFlashSaleProductModel {
    brandId: number;
    name: string;
    text: string;
    start: Date;
    end: Date;
    displayCount?: CollageDisplayCount;
    collageLayout?: CollageLayout;
    files: UploadPictureModel[];
}

export const createNewFlashSaleProductModel = (): NewFlashSaleProductModel => ({
    brandId: 0,
    name: "",
    text: "",
    start: new Date(0),
    end: new Date(0),
    displayCount: CollageDisplayCount.one,
    collageLayout: CollageLayout.allSquare,
    files: []
});

export interface OneTimeProductModel {
    files: UploadPictureModel[];
}